module.exports = require("/builds/portals_shops/melius-shop-frontend/src/store/createStore")